import React, { useEffect, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import Users from '../../Users';
import Categories from '../../Categories';
import DateRange from '../../DateRange';
import Archived from '../../Archived';
import { Link, useNavigate } from 'react-router';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Spinner } from 'reactstrap';
import useFilter from '../../../hooks/useFilter';
import useNavBar from '../../../hooks/useNavBar';

export default function ISODetailReportForm() {
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const users = Users();
    const categories = Categories();
    const dateRange = DateRange();
    const archived = Archived();

    const { filter, setFilter } = useFilter();
    const { loading, setLoading } = useNavBar();

    const headers = 
        [
            "Department",
            "Full Name",
            "College ID",
            "Course / Assignment",
            "Completion Date",
            "Duration(hours)",
            "Personnel ID",
            "ISA Topic",
            "ISA Instructor",
            "ISO Category",
        ];

    useEffect(() => {
        if (!users.loading && !dateRange.loading && !archived.loading){
            setLoading(false);
        }

        let adjustedHeaders = [
            ...headers,
            ...(users.includeInactiveUsers ? ["User Status"] : []), // end of user fields, which is end of array
            ...(archived.includeArchivedCompletions ? ["Enrollment Status", "Archived Date"] : []) // end of all fields
        ];

        setFilter({
            users: users.selectedUsers.map(user => user.value),
            groups: users.selectedGroups.map(group => group.value),
            categories: categories.selectedCategories,
            selectAllCategories: categories.selectAll,
            headers: adjustedHeaders,
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            includeArchivedCompletions: archived.includeArchivedCompletions,
            hasArchivedCompletions: archived.hasArchivedCompletions,
            recordGrouping: (filter?.recordGrouping ?? 0),

            selectAllUsers: users.selectAll,
            formUsers: users.users,            
            formGroups: users.groups,
            includeInactiveUsers: users.includeInactiveUsers,
            formCategories: categories.categories,
            formCategoryIds: categories.categoryIds,
            formExpandedCategories: categories.expandedCategories,
        });
    }, [users.loading,
        users.selectAll, 
        users.selectedUsers, 
        users.users, 
        users.selectedGroups, 
        users.groups,
        users.includeInactiveUsers,
        categories.selectAll,
        categories.categories,
        categories.selectedCategories,
        categories.categoryIds,
        categories.expandedCategories,
        dateRange.loading,
        dateRange.startDate, 
        dateRange.endDate,
        archived.includeArchivedCompletions,
        archived.hasArchivedCompletions
    ]); 

    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendfilter = (
            (
                { users, groups, categories, selectAllCategories, headers, startDate, endDate, includeArchivedCompletions, hasArchivedCompletions, recordGrouping }) =>
                ({ users, groups, categories, selectAllCategories, headers, startDate, endDate, includeArchivedCompletions, hasArchivedCompletions, recordGrouping })
        )(filter);

        try{
            await axiosPrivate.post('api/reports/isaaudit', sendfilter);
            navigate('/reports');
        }
        catch(err){
            console.log(err);
        }
    }

    return (
        loading ? <Spinner variant="primary" animation="border" role="status" className='custom-spinner'/> :
        <Container>
            <Col>
                <FormGroup>                            
                    <Card>
                        <CardBody>
                            <FormGroup>
                                {users.render}
                            </FormGroup>
                        </CardBody>
                    </Card>  
                </FormGroup>
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {categories.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                <FormGroup>
                    <Card>
                        <CardBody>
                            <FormGroup>
                                {dateRange.render}
                            </FormGroup>
                        </CardBody>
                    </Card>  
                    </FormGroup>
                    {
                        archived.hasArchivedCompletions ?
                            <FormGroup>
                                <Card>
                                    <CardBody>
                                        <FormGroup>
                                            {archived.render}
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </FormGroup>
                            :
                            null
                    }
            </Col>
            <footer>
                <Form onSubmit={handleSubmit}>
                    <Button color="primary">Generate Report</Button>
                    <Link to="/">
                        <Button className='btn-danger'>Back</Button>
                    </Link>
                </Form>
            </footer>
        </Container>
    );
}